import {
  Card,
  Group,
  TextInput,
  Stack,
  Text,
  NumberInput,
} from '@mantine/core';
import { type ApplicantDetailed } from '@/schemas/API/GET/applicant/response';

interface AddressCardProps {
  addressType: string;
  disabled?: boolean;
  formContext: any;
}

export const AddressCard: React.FC<AddressCardProps> = props => {
  const form = props.formContext();
  const addr: keyof ApplicantDetailed =
    props.addressType === 'Trvalá adresa' ? 'permAddress' : 'servAddress';

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <Text fw={700} size="large">
        {props.addressType}
      </Text>

      <Stack gap="sm" className="mt-3">
        <TextInput
          variant="filled"
          label="Ulice"
          radius="md"
          disabled={props.disabled}
          {...form.getInputProps(`${addr}.street`)}
        />

        <Group justify="space-between" grow className="flex items-start">
          <NumberInput
            variant="filled"
            label="Č.p."
            radius="md"
            hideControls
            value={
              form.values[addr].descNum !== 0 ? form.values[addr].descNum : ''
            }
            onChange={(n: any) => {
              form.setFieldValue(`${addr}.descNum`, Number(n));
            }}
            min={0}
            error={form.getInputProps(`${addr}.descNum`).error}
            allowDecimal={false}
            disabled={props.disabled}
          />
          <NumberInput
            variant="filled"
            label="Č.o."
            radius="md"
            hideControls
            value={
              form.values[addr].orientNum !== 0
                ? form.values[addr].orientNum
                : ''
            }
            onChange={(n: any) => {
              form.setFieldValue(`${addr}.orientNum`, Number(n));
            }}
            min={0}
            error={form.getInputProps(`${addr}.orientNum`).error}
            allowDecimal={false}
            disabled={props.disabled}
          />
        </Group>

        <TextInput
          variant="filled"
          label="Město"
          radius="md"
          {...form.getInputProps(`${addr}.city`)}
          disabled={props.disabled}
        />
        <TextInput
          variant="filled"
          label="PSČ"
          radius="md"
          value={form.values[addr].postCode}
          onChange={e => {
            const value = e.currentTarget.value;
            if (/^\d{0,5}$/.test(value)) {
              form.setFieldValue(`${addr}.postCode`, value);
            }
          }}
          error={form.getInputProps(`${addr}.postCode`).error}
          disabled={props.disabled}
        />
      </Stack>
    </Card>
  );
};
